export default function routeInfoToParams(routeInfo) {
  return !routeInfo ? undefined : [routeInfo.name]
    .concat(routeInfo.paramNames?.map(name => routeInfo.params[name]) ?? []);
}
